export default __webpack_public_path__ + "static/countdown_widget_medium-1170aaf6bf8d5f5f17976bfbad914b70.png";